import { createFileRoute, redirect } from "@tanstack/react-router";

// Legal/company info lives on /about. Crawlers and EU visitors request
// /imprint, so redirect permanently instead of serving a 404.
export const Route = createFileRoute("/imprint")({
  beforeLoad: () => {
    throw redirect({ to: "/about", statusCode: 301 });
  },
});
